module.exports = __webpack_public_path__ + "static/media/email icon.d21b3776.svg";